import React, { useState, useEffect } from 'react';
import './ContractScreen.css';
import { api } from '../../services/api';

const SUMMARY_ITEMS = [
  {
    key: 'paymentForContract',
    label: 'סה"כ תשלום לחוזה',
    description: 'סכום החוזה הכולל',
    featured: true,
  },
  {
    key: 'paymentByContractor',
    label: 'סה"כ שולם ע"י הקבלן',
    description: 'תשלומים שבוצעו על ידי הקבלן',
  },
  {
    key: 'receiptForPayment',
    label: 'סה"כ ניתנת קבלה לתשלום',
    description: 'קבלות פתוחות לתשלום',
  },
  {
    key: 'paymentByTenants',
    label: 'סה"כ שולם על ידי הדיירים',
    description: 'תשלומים שבוצעו על ידי דיירים',
  },
];

const formatAmount = (val) => {
  if (val === null || val === undefined || val === '') return '—';
  if (typeof val === 'object') return '—';
  if (typeof val === 'number') {
    return val.toLocaleString('he-IL');
  }
  return String(val);
};

export default function ContractScreen({ user, selectedContractId }) {
  const [fields, setFields] = useState({
    paymentForContract: '',
    paymentByContractor: '',
    receiptForPayment: '',
    paymentByTenants: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedContractId || !user) return;

    setFields({
      paymentForContract: '',
      paymentByContractor: '',
      receiptForPayment: '',
      paymentByTenants: '',
    });

    const fetchContractData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await api.getContractData(
          user.userCode,
          user.type,
          selectedContractId
        );

        if (response) {
          setFields({
            paymentForContract: formatAmount(response.totPaid),
            paymentByContractor: formatAmount(response.totCntrctPaid),
            receiptForPayment: formatAmount(response.sumReciept),
            paymentByTenants: formatAmount(response.totTnntsPaid),
          });
        }
      } catch (err) {
        console.error('Error fetching contract data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContractData();
  }, [selectedContractId, user]);

  if (loading) {
    return (
      <div className="contract-screen">
        <div className="contract-summary-card contract-summary-card--loading">
          <div className="contract-loading-spinner" aria-hidden="true" />
          <p className="contract-loading-text">טוען נתוני חוזה...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="contract-screen">
        <div className="contract-error-card">
          <span className="contract-error-icon" aria-hidden="true">!</span>
          <p className="contract-error-title">שגיאה בטעינת נתוני החוזה</p>
          <p className="contract-error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contract-screen">
      <div className="contract-summary-card">
        <div className="contract-summary-header">
          <h3 className="contract-summary-title">סיכום תשלומים</h3>
        </div>

        <div className="contract-summary-grid">
          {SUMMARY_ITEMS.map((item) => {
            const value = fields[item.key];
            const isZero = value === '0' || value === '—';

            return (
              <div
                key={item.key}
                className={[
                  'contract-summary-item',
                  item.featured ? 'contract-summary-item--featured' : '',
                  isZero ? 'contract-summary-item--muted' : '',
                ].filter(Boolean).join(' ')}
              >
                <div className="contract-summary-item-text">
                  <span className="contract-summary-label">{item.label}</span>
                  <span className="contract-summary-description">{item.description}</span>
                </div>
                <div className="contract-summary-value-wrap">
                  <span className="contract-summary-value">{value}</span>
                  {value !== '—' && <span className="contract-summary-currency">₪</span>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
